<template>
    <button
        class="font-montserrat text-xs block w-full bg-green-600 hover:bg-black text-white py-3 mb-4 transition-colors duration-300 uppercase tracking-widest font-bold"
        type="submit"
        @click="emitter.emit('open-payment-modal', payment)"
    >
        <font-awesome-icon icon="fa-solid fa-money-bill-wave" />
        &nbsp;
        <slot>Zahlung buchen</slot>
    </button>
</template>

<script setup>
import { defineProps, inject, toRefs } from "vue";

const props = defineProps({ payment: Object });

const { payment } = toRefs(props);

const emitter = inject("emitter");
</script>

<style></style>
